// extracted by mini-css-extract-plugin
export default {"container":"WarningMessage__container___MtR3l","icon":"WarningMessage__icon___gPBdw","text":"WarningMessage__text___j_qp8"};